export default "__VITE_ASSET__29fe23a4__"